import React from "react";

const WelcomeHeader = ({ stats, onReserveClick }) => {
  const todayBooking = stats?.todayBooking;

  return (
    <div className="mb-10 rounded-[24px] lg:rounded-[32px] bg-black px-8 py-6 text-white shadow-sm flex flex-col md:flex-row md:items-center justify-between gap-6 border border-white/10">
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-8 lg:gap-16 flex-1">

        {/* Today's Seat */}
        <div className="flex flex-col min-w-[180px]">
          <div className="flex items-center gap-2 mb-2">
            <span className="h-2.5 w-2.5 rounded-full bg-[#10b981] shadow-[0_0_8px_rgba(16,185,129,0.6)]" />
            <span className="text-[11px] font-extrabold uppercase tracking-widest text-slate-400">
              Today's Seat
            </span>
          </div>
          <h3 className="text-3xl font-black mb-1 text-white">
            {todayBooking?.seatLabel || "—"}
          </h3>
          <p className="text-[12px] text-slate-500 font-semibold tracking-tight">
            {todayBooking
              ? `${todayBooking.sectionName} · ${todayBooking.time}`
              : "No booking for today"}
          </p>
        </div>

        {/* Divider */}
        <div className="hidden sm:block h-12 w-[1px] bg-white/10" />

        {/* Active Bookings */}
        <div className="flex flex-col min-w-[180px]">
          <span className="text-[11px] font-extrabold uppercase tracking-widest text-slate-400 mb-2">
            Active Bookings
          </span>
          <h3 className="text-3xl font-black mb-1 text-white">
            {stats?.activeCount || 0}
          </h3>
          <p className="text-[12px] text-slate-500 font-semibold tracking-tight">
            Across {stats?.sectionCount || 0}{" "}
            {stats?.sectionCount === 1 ? "section" : "sections"}
          </p>
        </div>
      </div>

      {/* Reserve Button */}
      <div className="flex items-center">
        <button
          onClick={onReserveClick}
          className="group flex items-center gap-4 bg-white text-black px-7 py-3.5 rounded-[16px] font-black text-sm transition-all hover:scale-[1.02] hover:bg-slate-100 active:scale-95 whitespace-nowrap"
        >
          <span>Reserve a seat</span>
          <svg
            className="w-4 h-4 transition-transform group-hover:translate-x-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="3.5"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default WelcomeHeader;
